import { createFileRoute } from "@tanstack/react-router";
import { useClient } from "@trainwell/features/clients";
import { useFreemiumPlanDetails } from "@trainwell/features/freemium-plans";
import { useUserState } from "src/components/UserState";
import type { SelectionButtonProps } from "src/features/SelectionButtonProps";
import { useCurrentUserId } from "src/features/useCurrentUserId";
import WeekDaySelector from "src/features/WeekDaySelector";

export const Route = createFileRoute("/_layout/daysOfWeek")({
  component: RouteComponent,
});

function RouteComponent() {
  const setSelections = useUserState((state) => state.setSelections);
  const userId = useCurrentUserId();

  const { data: client } = useClient({
    userId: userId,
    queryConfig: { enabled: !!userId },
  });

  const { data: planDetails } = useFreemiumPlanDetails({
    planId: client?.freemium_plan_id ?? "",
  });

  const planDaysPerWeek = planDetails?.plan.target_frequency ?? 3;

  return (
    <WeekDaySelector
      titleText={`Which ${planDaysPerWeek} days of the week can you commit to working out?`}
      bodyText={`Try to spread them out throughout the week.`}
      numSelectionsRequired={planDaysPerWeek}
      selectionText={`We'll schedule your workouts for these ${planDaysPerWeek} days.`}
      onSelectionChange={(selectedDays: SelectionButtonProps[]) => {
        if (selectedDays.length > 0) {
          setSelections("/daysOfWeek", selectedDays);
        } else {
          setSelections("/daysOfWeek", undefined);
        }
      }}
    />
  );
}
